import React from "react";
import { Route, Redirect } from "react-router-dom";
import { routes } from "./routes";

const ProtectedRoute = (props) => {
  const subDomain = localStorage.getItem("subDomain");
  const isLoggedIn = localStorage.getItem("token");
  return (isLoggedIn && subDomain) ? (
    <Redirect
      to={{
        pathname: routes?.dashboard?.path,
      }}
    />
  ) : (
    <Route {...props} />
  );
};

export default ProtectedRoute;